import { LinkAnchor, TabView } from '@wrisk/ui-components'
import { TFunction } from 'i18next'
import React, { FunctionComponent, useCallback, useState } from 'react'

import { VehicleVIN } from '../../../../../domain'
import { TKeyBuilder } from '../../../../../infrastructure/internationalisation'
import { WriskTrans } from '../../../trans'
import { VehicleLookupVRN } from '../VehicleLookupVRN'
import { VehicleSelectValue, VehicleSelectVRN } from '../VehicleSelectVRN'
import { VehicleTabsConfigVRN } from './types'

export type VehicleTabsValue = Partial<{
  specification: VehicleVIN
  vrn: string
  regLookup: boolean
}>

export interface VehicleTabsVRNProps {
  t: TFunction
  tKey: TKeyBuilder
  tName: string
  initialTab: number
  config?: VehicleTabsConfigVRN
  value?: VehicleTabsValue
  onChange: (value?: VehicleTabsValue) => void
}

export const VehicleTabsVRN: FunctionComponent<VehicleTabsVRNProps> = ({
  t,
  tKey,
  tName,
  initialTab,
  config,
  value,
  onChange,
}) => {
  const [tab, setTab] = useState(initialTab)

  const onLookup = useCallback(
    (specification?: VehicleVIN) => {
      onChange({
        specification,
        regLookup: true,
        vrn: specification?.vrn ?? undefined,
      })
    },
    [onChange],
  )

  const onSelect = useCallback(
    (value?: VehicleSelectValue) => {
      onChange({ ...value, regLookup: false })
    },
    [onChange],
  )

  const onNotMyVehicleClick = useCallback(() => setTab(1), [])

  const tabItems = [
    {
      header: t(tKey(tName, 'tabHeaders.searchReg')),
      component: () => (
        <VehicleLookupVRN
          config={config}
          value={value?.vrn ?? undefined}
          onSearch={onLookup}
          error={
            <WriskTrans
              t={t}
              i18nKey={tKey(tName, 'validation', 'notFoundTabs')}
              components={{
                cta: <LinkAnchor variant='inline' onClick={onNotMyVehicleClick} />,
              }}
            />
          }
        />
      ),
    },
    {
      header: t(tKey(tName, 'tabHeaders.selectVehicle')),
      component: () => (
        <VehicleSelectVRN config={config} value={value} onChange={onSelect} />
      ),
    },
  ]

  return (
    <TabView width={1} key={tab} items={tabItems} tabIndex={tab} onTabChange={setTab} />
  )
}
